function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1696_12731)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.136 18.8639C7.60845 20.3364 9.54594 21.2527 11.6183 21.4567C13.6906 21.6607 15.7696 21.1398 17.5009 19.9827C19.2322 18.8256 20.5087 17.104 21.1129 15.1112C21.717 13.1184 21.6115 10.9778 20.8142 9.05408C20.0169 7.13039 18.5772 5.5427 16.7404 4.56158C14.9037 3.58045 12.7835 3.2666 10.7413 3.67352C8.69909 4.08043 6.86116 5.18293 5.54073 6.79312C4.22031 8.40332 3.49909 10.4216 3.5 12.5039V14.4999",
  stroke: "url(#paint0_linear_1696_12731)",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 12.5L3.5 14.5L5.5 12.5M11.5 8.5V13.5H16.5",
  stroke: "url(#paint1_linear_1696_12731)",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1696_12731",
  x1: 21.5,
  y1: 12.5,
  x2: 0.421052,
  y2: 12.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0ABBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#95D6DB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1696_12731",
  x1: 16.5,
  y1: 11.5,
  x2: -1.06579,
  y2: 11.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0ABBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#95D6DB"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1696_12731"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.5 0.5)"
})));

function SvgIconEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpty);
export default __webpack_public_path__ + "static/media/icon_empty.4136085b.svg";
export { ForwardRef as ReactComponent };